'use strict';

textBuilder.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textBuilder = textBuilder;
/*@ngInject*/
function textBuilder(gettextCatalog) {
    return {
        getProductNumberAndPromo: getProductNumberAndPromo
    };

    function getProductNumberAndPromo(productNumber, promocode) {
        var productNumberIsEmpty = !productNumber || productNumber.length <= 0;
        var promocodeIsEmpty = !promocode || promocode.length <= 0;

        if (productNumberIsEmpty && promocodeIsEmpty) {
            return '';
        }

        var productNumberLabel = gettextCatalog.getString('ProductNumber');
        var promocodeLabel = gettextCatalog.getString('PROMO');

        if (promocodeIsEmpty) {
            return productNumberLabel + ': ' + productNumber;
        }

        if (productNumberIsEmpty) {
            return promocodeLabel + ': ' + promocode;
        }

        return productNumberLabel + ': ' + productNumber + ', ' + promocodeLabel + ': ' + promocode;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/textBuilder.js
// module id = 832
// module chunks = 0